// angular dependencies
import { NgModule, Provider } from '@angular/core';

// fantaz dependencies
import { provideDataAccessConfig } from './data-access.config';
import { provideDataAccessWalletService } from './providers/wallet-service.providers';
import { provideDataAccessGameService } from './services';
import { AccountServiceImpl } from './services/account/account-service.impl';
import { provideDataAccessAccountService } from './services/account/account-service.providers';
import { provideAuthService } from './services/auth';
import { AuthCognitoServiceImpl } from './services/auth/auth-cognito-service.impl';
import { provideDataAccessBrowserService } from './services/browser';
import { BrowserServiceImpl } from './services/browser/browser-service.impl';
import { provideDataAccessConfigService } from './services/config';
import { ConfigServiceImpl } from './services/config/config-service.impl';
import { HttpApiGameService } from './services/games/impl/game-service-http-impl';
import { provideDataAccessMailingService } from './services/mailing';
import { MailingServiceImpl } from './services/mailing/mailing-service.impl';
import { provideDataAccessTournamentsService } from './services/tournaments';
import { TournamentsHttpApiService } from './services/tournaments/impl/tournaments-http-service-impl';
import { provideDataAccessUploadService } from './services/upload';
import { UploadServiceS3Impl } from './services/upload/upload-service-s3.impl';
import { WalletApiService } from './services/wallet-api.service';

export function provideDataAccess(): Provider[] {
  return [
    // TODO: Move every service to config
    provideDataAccessAccountService({
      useClass: AccountServiceImpl,
    }),
    provideDataAccessBrowserService({
      useClass: BrowserServiceImpl,
    }),
    provideDataAccessConfigService({
      useClass: ConfigServiceImpl,
    }),
    provideDataAccessWalletService({
      useClass: WalletApiService,
    }),
    provideDataAccessUploadService({
      useClass: UploadServiceS3Impl,
    }),
    provideDataAccessMailingService({
      useClass: MailingServiceImpl,
    }),
    provideAuthService({
      useClass: AuthCognitoServiceImpl,
    }),
    provideDataAccessGameService({
      useClass: HttpApiGameService,
    }),
    provideDataAccessTournamentsService({
      useClass: TournamentsHttpApiService,
    }),
  ];
}

@NgModule({
  providers: [provideDataAccess(), provideDataAccessConfig()],
})
export class ApiDataAccessModule {}
